import { AccountsListPageInitDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { AccountsListPageNew } from './AccountsListPageNew'
import { AccountsListPageOld } from './AccountsListPageOld'

const AccountsListPage = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  // Single lightweight query for feature flag and authorization
  // This avoids the duplicate query that useFeatures would cause
  const { data, loading, error } = useQuery(AccountsListPageInitDocument, {
    variables: { companyId },
  })

  const useDataCollection =
    data?.features?.featuresConnection?.nodes?.find(
      (f) => f.name === 'dev_finance_accounts_datacollection'
    )?.enabled ?? false

  const authorized = data?.finance?._policies?.sidebarSeeFinanceAccountsSubLevelItem?.can ?? false

  // Show nothing while loading to prevent flicker
  if (loading) {
    return null
  }

  // On error or feature flag off, fall back to legacy page
  // AccountsListPageOld has its own ResponsivePage.Body, so no wrapper needed
  if (error || !useDataCollection) {
    return <AccountsListPageOld />
  }

  // Feature flag on: wrap AccountsListPageNew (we removed its internal ResponsivePage.Body)
  return (
    <ResponsivePage.Body authorized={authorized} variant="full">
      <AccountsListPageNew />
    </ResponsivePage.Body>
  )
}

export default AccountsListPage
